/*
 * NOURION Anfrageliste.
 *
 * Zwei Ebenen in einer Datei:
 *  1) window.NourionCart: die Speicher-Engine (add, remove, setQty, clear,
 *     read) auf localStorage 'nourion-cart-v2', mit Validierung gegen
 *     kaputte/manipulierte Daten (isValidItem).
 *  2) Der Drawer-Regler darunter (privat, nicht auf window).
 *
 * Seit dem Umbau auf das reine Anfragemodell (20.08.2026) gibt es hier
 * KEINE Preise, KEINE Summen und KEINEN Checkout mehr: Kundinnen und Kunden
 * stellen Leistungen zusammen und senden die ganze Liste als eine Anfrage
 * ueber das Kontaktformular. Der Schluesselwechsel v1 -> v2 verwirft alte
 * Koerbe mit Preisdaten bewusst.
 *
 * Kopplung zwischen Bausteinen NUR ueber zwei Events auf document:
 *   'nourion:cart:open'    -> oeffnet den Drawer (z. B. Klick auf den
 *                             Listen-Knopf in der Navigation)
 *   'nourion:cart:changed' -> detail { items, count }, fuer das Badge
 *
 * Reinitialisierung: Die Listener auf document werden genau einmal pro
 * Seite gebunden (Wache ueber window.__nourionCartBound), damit ein erneutes
 * Ausfuehren dieses Skripts (z. B. wenn der Header im Theme-Editor per
 * shopify:section:load neu gerendert wird) keine doppelten Listener auf dem
 * dauerhaften document-Objekt erzeugt. Alle DOM-Zugriffe suchen das aktuelle
 * #nourion-cart-root zur Laufzeit frisch, dadurch funktioniert das auch nach
 * einem Neu-Rendern des Headers ohne separates Re-Binding pro Knoten.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'nourion-cart-v2';
  var VALID_KINDS = ['einmalig', 'monatlich', 'audit'];

  var KIND_LABEL = { einmalig: 'einmalig', monatlich: 'monatlich', audit: 'Audit erbeten' };

  var GROUPS = [
    { kind: 'einmalig', title: 'Einmalige Leistungen' },
    { kind: 'monatlich', title: 'Laufende Betreuung', note: 'monatlich kündbar' },
    { kind: 'audit', title: 'Nach IT Audit', note: 'Umfang und Angebot folgen nach dem Audit' }
  ];

  var ICON_PATHS = {
    minus: '<path d="M5 12h14"/>',
    plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    trash: '<path d="M10 11v6"/><path d="M14 11v6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>'
  };

  function icon(name, size) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON_PATHS[name] + '</svg>';
  }

  /* ══════════════════════════════════════════════════════════════════
     1) Speicher-Engine
     ══════════════════════════════════════════════════════════════════ */

  /* Prueft jede Position: schuetzt vor altem/manipuliertem localStorage.
     Kaputte Daten duerfen weder krumme Mengen (qty) noch fremde Gruppen
     (kind) erzeugen. */
  function isValidItem(item) {
    if (!item || typeof item !== 'object') return false;
    return (
      typeof item.key === 'string' && item.key.length > 0 &&
      typeof item.title === 'string' && item.title.length > 0 &&
      typeof item.kind === 'string' && VALID_KINDS.indexOf(item.kind) !== -1 &&
      (item.sub === undefined || typeof item.sub === 'string') &&
      typeof item.qty === 'number' && item.qty % 1 === 0 && item.qty >= 1 &&
      typeof item.maxQty === 'number' && item.maxQty % 1 === 0 && item.maxQty >= 1
    );
  }

  function loadItems() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      /* qty beim Laden auf maxQty klemmen: alte Listen mit zu hoher Menge
         sollen die Liste nicht sprengen, sondern still korrigiert werden. */
      return parsed.filter(isValidItem).map(function (item) {
        var copy = {};
        for (var k in item) if (Object.prototype.hasOwnProperty.call(item, k)) copy[k] = item[k];
        copy.qty = Math.min(item.qty, item.maxQty);
        return copy;
      });
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* Speicher voll/blockiert: die Liste funktioniert weiter, nur ohne Persistenz. */
    }
  }

  function emitChanged(items) {
    var count = items.reduce(function (n, i) { return n + i.qty; }, 0);
    document.dispatchEvent(new CustomEvent('nourion:cart:changed', { detail: { items: items, count: count } }));
  }

  function cartAdd(item) {
    if (!isValidItem(item)) {
      if (window.console) console.warn('NourionCart.add: ungültige Position verworfen', item);
      return;
    }
    var items = loadItems();
    var existing = null;
    for (var i = 0; i < items.length; i++) { if (items[i].key === item.key) { existing = items[i]; break; } }
    if (existing) {
      existing.qty = Math.min(existing.qty + item.qty, existing.maxQty);
    } else {
      items.push(item);
    }
    saveItems(items);
    emitChanged(items);
    /* Oeffnet den Drawer automatisch. Das Detail 'stamped' signalisiert, dass
       eine Position frisch dazukam (kurzer Siegel-Puls im Kopf). Das blosse
       Oeffnen ueber den Navi-Knopf (assets/nourion-header.js) traegt dieses
       Detail bewusst nicht. */
    document.dispatchEvent(new CustomEvent('nourion:cart:open', { detail: { stamped: true } }));
  }

  function cartRemove(key) {
    if (typeof key !== 'string') return;
    var items = loadItems().filter(function (i) { return i.key !== key; });
    saveItems(items);
    emitChanged(items);
  }

  function cartSetQty(key, qty) {
    if (typeof key !== 'string' || typeof qty !== 'number' || !isFinite(qty)) return;
    var items = loadItems().map(function (i) {
      if (i.key !== key) return i;
      var copy = {};
      for (var k in i) if (Object.prototype.hasOwnProperty.call(i, k)) copy[k] = i[k];
      copy.qty = Math.max(1, Math.min(qty, i.maxQty));
      return copy;
    });
    saveItems(items);
    emitChanged(items);
  }

  function cartClear() {
    saveItems([]);
    emitChanged([]);
  }

  function cartRead() {
    return loadItems();
  }

  window.NourionCart = {
    add: cartAdd,
    remove: cartRemove,
    setQty: cartSetQty,
    clear: cartClear,
    read: cartRead
  };

  /* ══════════════════════════════════════════════════════════════════
     2) Anfragetext (preisfrei), nur intern fuer den Drawer benutzt
     ══════════════════════════════════════════════════════════════════ */

  function buildCartInquiry(items) {
    var lines = items.map(function (i) {
      var qty = i.qty > 1 ? ' × ' + i.qty : '';
      var sub = i.sub ? ' (' + i.sub + ')' : '';
      return '• ' + i.title + sub + qty + ' [' + KIND_LABEL[i.kind] + ']';
    });
    return (
      'Meine Auswahl aus der Anfrageliste:\n' +
      lines.join('\n') +
      '\n\nBitte senden Sie mir ein unverbindliches Angebot.'
    );
  }

  /* ══════════════════════════════════════════════════════════════════
     3) Geteilte Scroll-Sperre: gezaehlt, damit sie sich mit anderen
        Overlays (z. B. Mobilmenue) nicht in die Quere kommt. Auf window,
        falls andere Bausteine sie mitbenutzen wollen.
     ══════════════════════════════════════════════════════════════════ */

  window.NourionScrollLock = window.NourionScrollLock || (function () {
    var count = 0;
    return {
      acquire: function () {
        count += 1;
        if (count === 1) document.body.style.overflow = 'hidden';
      },
      release: function () {
        count = Math.max(0, count - 1);
        if (count === 0) document.body.style.overflow = '';
      }
    };
  })();

  /* ══════════════════════════════════════════════════════════════════
     4) Drawer-Regler
     ══════════════════════════════════════════════════════════════════ */

  var opener = null;

  function getRoot() { return document.getElementById('nourion-cart-root'); }

  function renderItemRow(item) {
    var li = document.createElement('li');
    li.className = 'nourion-cart-item';

    var main = document.createElement('div');
    main.className = 'nourion-cart-item-main';

    var title = document.createElement('p');
    title.className = 'nourion-cart-item-title';
    title.textContent = item.title;
    main.appendChild(title);

    if (item.sub) {
      var sub = document.createElement('p');
      sub.className = 'nourion-cart-item-sub';
      sub.textContent = item.sub;
      main.appendChild(sub);
    }

    if (item.maxQty > 1) {
      var stepper = document.createElement('span');
      stepper.className = 'nourion-cart-stepper';

      var minusBtn = document.createElement('button');
      minusBtn.type = 'button';
      minusBtn.className = 'nourion-cart-step-btn';
      minusBtn.setAttribute('data-cart-qty-minus', '');
      minusBtn.setAttribute('data-key', item.key);
      minusBtn.setAttribute('aria-label', 'Menge verringern: ' + item.title);
      minusBtn.disabled = item.qty <= 1;
      minusBtn.innerHTML = icon('minus', 13);
      stepper.appendChild(minusBtn);

      var value = document.createElement('span');
      value.className = 'nourion-cart-step-value';
      value.textContent = String(item.qty);
      stepper.appendChild(value);

      var plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.className = 'nourion-cart-step-btn';
      plusBtn.setAttribute('data-cart-qty-plus', '');
      plusBtn.setAttribute('data-key', item.key);
      plusBtn.setAttribute('aria-label', 'Menge erhöhen: ' + item.title);
      plusBtn.disabled = item.qty >= item.maxQty;
      plusBtn.innerHTML = icon('plus', 13);
      stepper.appendChild(plusBtn);

      main.appendChild(stepper);
    }

    li.appendChild(main);

    var side = document.createElement('div');
    side.className = 'nourion-cart-item-side';

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'nourion-cart-item-remove';
    removeBtn.setAttribute('data-cart-remove', '');
    removeBtn.setAttribute('data-key', item.key);
    removeBtn.setAttribute('aria-label', 'Entfernen: ' + item.title);
    removeBtn.innerHTML = icon('trash', 12) + 'Entfernen';
    side.appendChild(removeBtn);

    li.appendChild(side);
    return li;
  }

  function renderGroups(container, items) {
    /* Fade nur bei STRUKTURELLER Aenderung (Position dazu oder weg), erkannt
       an der Reihenfolge der Keys. Reine Mengenaenderung laesst die Signatur
       gleich, dort pulst stattdessen die Ziffer. So flackert die Liste nicht
       bei jedem Stepper-Klick. */
    var sig = items.map(function (i) { return i.key; }).join('|');
    var structuralChange = container.getAttribute('data-sig') !== sig;
    container.innerHTML = '';
    GROUPS.forEach(function (g) {
      var group = items.filter(function (i) { return i.kind === g.kind; });
      if (!group.length) return;
      var section = document.createElement('section');
      section.className = 'nourion-cart-group';

      var h3 = document.createElement('h3');
      h3.className = 'k-eyebrow nourion-cart-group-title';
      h3.textContent = g.title;
      section.appendChild(h3);

      if (g.note) {
        var note = document.createElement('p');
        note.className = 'nourion-cart-group-note';
        note.textContent = g.note;
        section.appendChild(note);
      }

      var ul = document.createElement('ul');
      ul.className = 'nourion-cart-items';
      group.forEach(function (item) { ul.appendChild(renderItemRow(item)); });
      section.appendChild(ul);

      container.appendChild(section);
    });
    container.setAttribute('data-sig', sig);
    if (structuralChange) {
      /* Klasse neu anstossen: entfernen, Reflow erzwingen, wieder setzen,
         sonst spielt dieselbe Animation beim naechsten Mal nicht erneut. */
      container.classList.remove('is-fresh');
      void container.offsetWidth;
      container.classList.add('is-fresh');
    }
  }

  function render() {
    var root = getRoot();
    if (!root) return;
    var items = cartRead();
    var emptyEl = root.querySelector('[data-cart-empty]');
    var bodyEl = root.querySelector('[data-cart-body]');

    if (!items.length) {
      if (emptyEl) emptyEl.hidden = false;
      if (bodyEl) bodyEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (bodyEl) bodyEl.hidden = false;

    var groupsEl = root.querySelector('[data-cart-groups]');
    if (groupsEl) renderGroups(groupsEl, items);
  }

  function focusables(panel) {
    var list = panel.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      /* offsetParent === null erfasst display:none (u. a. den gerade
         unsichtbaren Leer- bzw. Gefuellt-Zweig) und filtert ihn aus der
         Fokus-Falle heraus. */
      if (!el.disabled && el.offsetParent !== null) out.push(el);
    }
    return out;
  }

  /* Kurzer Siegel-Puls im Kopf als Rueckmeldung, dass eine Position frisch in
     die Liste fiel. Reduced-motion schaltet die Animation in der CSS ab. */
  function stampSeal(root) {
    var seal = root && root.querySelector('.nourion-cart-seal');
    if (!seal) return;
    seal.classList.remove('is-stamped');
    void seal.offsetWidth; /* Reflow, damit die Animation erneut anspringt */
    seal.classList.add('is-stamped');
  }

  function openDrawer(e) {
    var root = getRoot();
    if (!root) return;
    var wasOpen = !root.hidden;
    render();
    if (!wasOpen) {
      /* Nur beim echten Oeffnen Fokus merken und Scroll-Sperre zaehlen. Ein
         zweites 'open' auf dem bereits offenen Drawer (z. B. weiteres
         Hinzufuegen) wuerde die gezaehlte Sperre sonst ohne Gegenstueck
         erhoehen. */
      opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      root.hidden = false;
      window.NourionScrollLock.acquire();
    }
    var stamped = !!(e && e.detail && e.detail.stamped);
    /* Reflow abwarten, sonst greift der Uebergang nicht (Element war eben
       noch display:none). */
    window.requestAnimationFrame(function () {
      root.classList.add('is-open');
      if (!wasOpen) {
        var closeBtn = root.querySelector('[data-cart-close]');
        if (closeBtn) closeBtn.focus();
      }
      if (stamped) stampSeal(root);
    });
  }

  function closeDrawer() {
    var root = getRoot();
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    window.NourionScrollLock.release();

    var panel = root.querySelector('.nourion-cart-panel');
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      root.hidden = true;
      if (panel) panel.removeEventListener('transitionend', finish);
    };
    if (panel) {
      panel.addEventListener('transitionend', finish);
      window.setTimeout(finish, 450); /* Sicherheitsnetz, falls transitionend ausbleibt */
    } else {
      finish();
    }

    if (opener) { opener.focus(); opener = null; }
  }

  function handleInquiryClick() {
    if (window.Shopify && window.Shopify.designMode) return; /* Editor Vorschau nicht wegnavigieren */
    var text = buildCartInquiry(cartRead());
    try { window.sessionStorage.setItem('nourion-anfrage', text); } catch (e) { /* Speicher blockiert, Navigation trotzdem fortsetzen */ }
    closeDrawer(); /* Liste bleibt gefuellt, bis die Anfrage wirklich gesendet ist */
    window.location.href = '/pages/kontakt-nourion';
  }

  function stepQty(key, delta) {
    var items = cartRead();
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === key) { cartSetQty(key, items[i].qty + delta); return; }
    }
  }

  /* Kurzer Puls der Ziffer nach +/-, als Bestaetigung der Mengenaenderung.
     Wird nach dem Neuaufbau der Liste aufgerufen; die Ziffer ist dann frisch,
     das Entfernen der Klasse also ein No-Op, das Setzen startet die
     Animation. Reduced-motion schaltet sie in der CSS ab. */
  function pulseStep(root, key) {
    if (!root) return;
    var btn = root.querySelector('[data-cart-qty-minus][data-key="' + key + '"], [data-cart-qty-plus][data-key="' + key + '"]');
    var stepper = btn ? btn.closest('.nourion-cart-stepper') : null;
    var value = stepper ? stepper.querySelector('.nourion-cart-step-value') : null;
    if (!value) return;
    value.classList.remove('is-pulse');
    void value.offsetWidth;
    value.classList.add('is-pulse');
  }

  /* Ein einziger delegierter Klick-Regler auf document: unabhaengig davon,
     ob #nourion-cart-root nach einem shopify:section:load ein neuer Knoten
     ist, funktioniert die Delegation sofort weiter, ohne Re-Binding. */
  function onDocumentClick(e) {
    var root = getRoot();
    if (!root || root.hidden) return;
    var target = e.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-cart-overlay]') || target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    if (target.closest('[data-cart-clear]')) { cartClear(); return; }
    if (target.closest('[data-cart-inquiry]')) { handleInquiryClick(); return; }

    var removeBtn = target.closest('[data-cart-remove]');
    if (removeBtn) {
      var removeKey = removeBtn.getAttribute('data-key');
      cartRemove(removeKey);
      restoreFocus(root, removeKey, 'remove');
      return;
    }

    var minusBtn = target.closest('[data-cart-qty-minus]');
    if (minusBtn) {
      var minusKey = minusBtn.getAttribute('data-key');
      stepQty(minusKey, -1);
      restoreFocus(root, minusKey, 'minus');
      pulseStep(root, minusKey);
      return;
    }

    var plusBtn = target.closest('[data-cart-qty-plus]');
    if (plusBtn) {
      var plusKey = plusBtn.getAttribute('data-key');
      stepQty(plusKey, 1);
      restoreFocus(root, plusKey, 'plus');
      pulseStep(root, plusKey);
      return;
    }
  }

  /* Fokus nach dem Neuaufbau der Gruppenliste wiederherstellen: ohne dies
     faellt die Tastatur nach jedem Stepper oder Entfernen Klick aus dem
     Dialog (das innerHTML Rendern ersetzt den fokussierten Knopf). */
  function restoreFocus(root, key, art) {
    // :not([disabled]) ist Pflicht: focus() auf einem gesperrten Knopf (Minus
    // bei Menge 1, Plus bei Maximalmenge) ist ein No-Op und der Fokus fiele
    // nach dem innerHTML Neuaufbau auf den body.
    var ziel = null;
    if (art === 'minus') ziel = root.querySelector('[data-cart-qty-minus][data-key="' + key + '"]:not([disabled])');
    else if (art === 'plus') ziel = root.querySelector('[data-cart-qty-plus][data-key="' + key + '"]:not([disabled])');
    if (!ziel && art !== 'remove') {
      var gegen = art === 'minus' ? '[data-cart-qty-plus]' : '[data-cart-qty-minus]';
      ziel = root.querySelector(gegen + '[data-key="' + key + '"]:not([disabled])');
    }
    if (!ziel && art !== 'remove') ziel = root.querySelector('[data-cart-remove][data-key="' + key + '"]');
    if (!ziel) {
      ziel = root.querySelector('[data-cart-qty-minus]:not([disabled]), [data-cart-qty-plus]:not([disabled]), [data-cart-remove], [data-cart-clear], [data-cart-close]');
    }
    if (ziel && typeof ziel.focus === 'function') ziel.focus();
  }

  /* Tastatur: Escape schliesst, Tab kreist im Dialog (WAI-ARIA Fokus-Falle). */
  function onDocumentKeydown(e) {
    var root = getRoot();
    if (!root || root.hidden) return;

    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;

    var panel = root.querySelector('.nourion-cart-panel');
    if (!panel) return;
    var list = focusables(panel);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;

    if (e.shiftKey && (active === first || !panel.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !panel.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  }

  if (!window.__nourionCartBound) {
    document.addEventListener('nourion:cart:open', openDrawer);
    document.addEventListener('nourion:cart:changed', function () {
      var root = getRoot();
      if (root && !root.hidden) render();
    });
    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onDocumentKeydown);
    window.__nourionCartBound = true;
  }

  /* Theme-Editor: rendert der Header (und damit dieses Snippet) eine Section
     neu, bleibt der Drawer ohne erneute Fehlerquelle funktionsfaehig, da
     alle Zugriffe oben ohnehin live ueber getRoot() laufen. War der Drawer
     gerade offen, hier nur den Inhalt aktualisieren. */
  document.addEventListener('shopify:section:load', function () {
    var root = getRoot();
    if (root && !root.hidden) render();
  });
})();
